export default __webpack_public_path__ + "static/media/ic_faceprint.ee749fa7.svg";